import { useQuery } from '@tanstack/react-query';
import type { PublicSiteConfig } from '@/types/site-config';

export function useSiteConfig() {
  return useQuery<PublicSiteConfig>({
    queryKey: ['site-config'],
    queryFn: async () => {
      const response = await fetch('/api/config');
      if (!response.ok) throw new Error('Failed to load site config');
      return response.json() as Promise<PublicSiteConfig>;
    },
    staleTime: 60 * 60 * 1000,
    gcTime: Infinity,
  });
}
